import React, { Suspense, lazy, useEffect, useState } from 'react'
import { useAppDispatch } from '../../../store'
import { type ApplyFiltersAndDispatchParams } from '../../../components/CustomTable/types'
import PAGE_TITLES from '../../../consts/titles'
import LoadingPageV2 from '../../../pages/LoadingPageV2'
import { useParams } from 'react-router-dom'
import { getTermsSectionsApi } from '../../../store/slices/termsSectionsSlice/api'
import { getTermsSectionsList, loading } from '../../../store/slices/termsSectionsSlice/selectors'
import { CreateAndEditTermsSection } from './CreateAndEditTermsSection'
import DeleteSection from './DeleteSection'
import { Box } from '@mui/material'
import TermsTopbarActions from './TermsTopbarActions'

const AppTable = lazy(async () => await import('../../../components/CustomTable'))

const TermsSectionTable: React.FC = () => {
  const [params, setParms] = useState<ApplyFiltersAndDispatchParams>({ pageSize: 5 })

  const { id } = useParams()

  const isLoading = loading()
  const termsSectionList = getTermsSectionsList()
  const dispatch = useAppDispatch()

  const queryParams = { ...params, termId: id }

  useEffect(() => {
    void dispatch(getTermsSectionsApi({ params: queryParams }))
  }, [params, id])

  return (
    <Box mt={5}>
      <Suspense fallback={<LoadingPageV2 title={PAGE_TITLES.TERMS} />}>
        <AppTable
          createAction={<CreateAndEditTermsSection params={queryParams} />}
          customTopbarAction={<TermsTopbarActions params={queryParams} />}
          editAction={<CreateAndEditTermsSection params={queryParams} />}
          list={termsSectionList}
          loading={isLoading}
          deleteAction={<DeleteSection />}
          featureName="Courses"
          params={params}
          setParams={setParms}
        />
      </Suspense>
    </Box>
  )
}

export default TermsSectionTable
